import script from "./myOrderDonePage.vue?vue&type=script&setup=true&lang=js"
export * from "./myOrderDonePage.vue?vue&type=script&setup=true&lang=js"

import "./myOrderDonePage.vue?vue&type=style&index=0&id=5ed5abfe&lang=css"

const __exports__ = script;

export default __exports__